import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight } from 'lucide-react';
import { Card } from './ui/card';

interface RelatedArticle {
  title: string;
  description: string;
  href: string;
}

interface RelatedArticlesProps {
  articles: RelatedArticle[];
  title?: string;
}

export const RelatedArticles: React.FC<RelatedArticlesProps> = ({ 
  articles, 
  title = "Related Articles" 
}) => {
  return (
    <section className="mt-16 mb-8">
      <h2 className="text-2xl font-bold mb-6">{title}</h2>
      <div className="grid md:grid-cols-2 gap-6">
        {articles.map((article) => (
          <Card key={article.href} className="p-6 hover:shadow-lg transition-shadow">
            <Link to={article.href} className="group">
              <h3 className="text-lg font-semibold mb-2 group-hover:text-oli-blue transition-colors">
                {article.title}
              </h3>
              <p className="text-muted-foreground text-sm mb-4">
                {article.description}
              </p>
              <span className="inline-flex items-center text-oli-blue text-sm font-medium group-hover:gap-2 transition-all">
                Read more <ArrowRight className="w-4 h-4 ml-1" />
              </span>
            </Link>
          </Card>
        ))}
      </div>
    </section>
  );
};